// ==== action types ====

export const SELECT_HEALTH_BASIC_PLAN = 'SELECT_HEALTH_BASIC_PLAN'
export const selectHealthBasicPlan = (planCode) => ({
  type: SELECT_HEALTH_BASIC_PLAN,
  payload: { planCode },
})

export const SELECT_BASIC_PLAN = 'SELECT_BASIC_PLAN'
export const selectBasicPlan = (product) => ({
  type: SELECT_BASIC_PLAN,
  payload: product,
})
